import { preLoadCalendarBoardAssets } from 'owa-calendar-board-assets';
import {
    bootstrapCalendarBoardProject,
    DefaultBoardCreationState,
    getDefaultBoardCreationState,
    loadCalendarBoardProjects,
} from 'owa-calendar-board-projects';
import { preLoadTimeStreamCanvas } from 'owa-timestream-canvas';
import { lazyCreateProject } from 'owa-calendar-board-welcome';

let isBoardInitialized = false;

export function bootstrapCalendarBoard() {
    if (!isBoardInitialized) {
        isBoardInitialized = true;

        bootstrapCalendarBoardProject();
        preLoadTimeStreamCanvas();
        preLoadCalendarBoardAssets();
    }
}

export function retryLoadCalendarBoardProjects(canvasBounds: DOMRect) {
    if (getDefaultBoardCreationState() === DefaultBoardCreationState.ErrorCreateNew) {
        lazyCreateProject.importAndExecute(canvasBounds);
    } else {
        loadCalendarBoardProjects();
    }
}
